export class Category {
    constructor(
        public id: any,
        public color: string,
        public title: string,
        public description: string,
        public need_pro: boolean,
        public is_available: boolean,
        public activate_users: string[],
        public sub_categories: string,
        public tasks_amount: number,
        public icon_url: string
    ) { }
}
